import React from "react";
import classNames from "classnames";
// @ts-ignore
import { Helmet } from "react-helmet";

type BaseLayoutProps = {
  children: React.ReactNode;
  testerAccount?: boolean;
  auth?: boolean;
};

const BaseLayout = ({ children, testerAccount, auth }: BaseLayoutProps) => (
  <div className={classNames({ "tester-account": testerAccount, "tester-work": auth })}>
    <Helmet title="Tester Work" titleTemplate="%s | Tester Work" />
    {children}
  </div>
);

export default BaseLayout;
